import { supabase } from '../supabaseClient';

const MEDIA_BUCKET = 'shinyvault-media';

// One place to delete a product from, used by every "Delete" control (the
// inline shop-grid buttons, the admin list, and the admin edit page) so the
// behavior is identical everywhere.
//
// The database does most of the cleanup on its own via foreign keys:
//   product_media  -> ON DELETE CASCADE  (rows removed with the product)
//   wishlist_items -> ON DELETE CASCADE
//   order_items    -> ON DELETE SET NULL (order HISTORY is preserved; the
//                     line item keeps its snapshot, just unlinks the product)
//   want_list_items.matched_product_id -> ON DELETE SET NULL
//
// What the database does NOT clean up is the actual image files in storage —
// deleting the product_media row leaves the object orphaned in the bucket. So
// we remove those files ourselves first, exactly like removePhoto does on the
// edit page. Externally hosted media (full http URLs, e.g. the TCGdex seed
// singles) live on another CDN and are left alone.
export async function deleteProduct(productId) {
  const { data: mediaRows } = await supabase
    .from('product_media')
    .select('storage_path')
    .eq('product_id', productId);

  const paths = (mediaRows || [])
    .map((m) => m.storage_path)
    .filter((p) => p && !/^https?:\/\//.test(p));

  if (paths.length) {
    // Best-effort: a failed storage remove leaves an orphaned file but must
    // not block the product delete. The row delete below is the thing that
    // actually pulls the item from the shop.
    await supabase.storage.from(MEDIA_BUCKET).remove(paths);
  }

  return supabase.from('products').delete().eq('id', productId);
}
